export enum AdvertAttribute {
  HOME_DELIVERY = "home-delivery",
  LIVE_VIDEO_VIEWING = "live-video-viewing",
}
